import Api from "../api";

class ShareRevenue {
  editUpdateShareRevenue = async (data = {}) => {
    const { body } = await Api.post(`shareRevenue`, data);
    return body;
  };
  getShareRevenue = async () => {
    const { body } = await Api.get(`shareRevenue`);
    return body;
  };
}
// eslint-disable-next-line
export default new ShareRevenue();
